import { Link, useLocation } from "react-router-dom";
import PageShell from "../components/layout/PageShell";

/**
 * Ruta comodín del router. Solo se ve al navegar dentro de la SPA hacia una
 * ruta inexistente: al entrar en frío, Apache ya corta antes con un 404 real y
 * sirve `public/404.html`.
 */
export default function NotFound() {
	const location = useLocation();

	return (
		<PageShell>
			<title>Página no encontrada | SpartechRD</title>
			<meta name="robots" content="noindex" />
			<div className="sp-container sp-section" style={{ textAlign: "center" }}>
				<p className="sp-title sp-accent" style={{ fontSize: "5rem" }}>404</p>
				<h1 className="sp-title">Esta página no existe</h1>
				<p className="sp-subtitle">El enlace que seguiste está roto o la página se movió.</p>
				<p style={{ fontFamily: "monospace", fontSize: "0.75rem", color: "var(--sp-muted)", wordBreak: "break-all" }}>
					{location.pathname}
				</p>
				<div style={{ display: "flex", flexWrap: "wrap", justifyContent: "center", gap: "0.75rem", marginTop: "2rem" }}>
					<Link to="/" className="sp-btn sp-btn-red">Inicio</Link>
					<Link to="/products" className="sp-btn sp-btn-red">Productos</Link>
					<Link to="/contacto" className="sp-btn sp-btn-red">Contacto</Link>
				</div>
			</div>
		</PageShell>
	);
}
